module.exports = __webpack_public_path__ + "img/bg_avatar_male_36.3024553b.png";